import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { IMPACT, IMAGES } from "@/data/content";
import { SectionHeading } from "./ui";
import { Reveal } from "./Reveal";

export default function ImpactSection() {
  return (
    <section className="relative bg-brand-bordeaux py-20 lg:py-32 grain-overlay overflow-hidden">
      {/* faint image texture */}
      <img
        src={IMAGES.vineyardHillside}
        alt=""
        aria-hidden
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.08]"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <SectionHeading dark eyebrow={IMPACT.eyebrow} title={IMPACT.title} />
        <Reveal delay={2}>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-brand-ivory/70">
            {IMPACT.disclaimerTop}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px bg-brand-ivory/10 border border-brand-ivory/10 rounded-sm overflow-hidden">
          {IMPACT.kpis.map((k, i) => (
            <Reveal key={k.label} delay={i % 4}>
              <div data-testid={`kpi-${i}`} className="bg-brand-bordeaux p-6 lg:p-8 h-full">
                <div
                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider ${
                    k.dir === "up"
                      ? "bg-brand-green/20 text-[#7fd6a0]"
                      : "bg-brand-gold/20 text-brand-gold"
                  }`}
                >
                  {k.dir === "up" ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
                  {k.dir === "up" ? "Aumenta" : "Diminuisce"}
                </div>
                <p className="mt-4 font-serif text-lg lg:text-xl text-brand-ivory leading-tight">{k.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
